export default {
  exit: {
    title: 'Plik lub pliki nie zostały wysłane do lektora.',
    text: 'Czy na pewno chcesz wyjść ze strony?',
    confirm: 'Pozostań',
    cancel: 'Opuść stronę',
  },
  success: {
    title: 'Twoja praca domowa została wysłana do lektora.',
    confirm: 'Ok',
  },
  error: {
    title: 'Coś poszło nie tak.',
    text: 'Skontaktuj się z Twoim lektorem.',
    confirm: 'Ok',
  },
  error_mailgun: {
    title: 'Coś poszło nie tak.',
    text: 'Spróbuj ponownie później.',
    confirm: 'Ok',
  },
  error_empty_list: {
    title: 'Nie załadowano żadnych plików do wysłania.',
    text: 'Wybierz plik i spróbuj ponownie.',
    confirm: 'Ok',
  },
  error_size: {
    title: 'Przekroczyłeś rozmiar plików.',
    text: 'Usuń za duże załączniki.',
    confirm: 'Ok',
  },
  error_size_single_file: {
    title: 'Przekroczyłeś limit 25 MB.',
    title_without: 'Przekroczyłeś limit ',
    text: 'Nie można dołączyć plików do Twojej pracy domowej',
    confirm: 'Ok',
  },
  welcome_popup: {
    header: 'Witamy w Early Stage Online!',
    button: 'Rozpocznij',
  },
};
